<template>
    <div>
      <div class="loading" v-if="isLoading">
        <b-loading :is-full-page="true" :active="true"></b-loading>
      </div>
      <div v-else>
        <section class="activate-membership section">
            <div class="container">
              <h1 class="title page-title has-padding-v-50 is-4 has-text-centered">Products & Billing</h1>
              <div class="row">
                <!-- <a class="button account__billing-box__edit-btn is-outlined is-inverted" @click.prevent="$router.push('/payment')" style="margin-right:15px">Payments</a> -->
                <a class="button account__billing-box__edit-btn is-outlined is-inverted" @click.prevent="$router.push('/billing/new')">New Product</a>
              </div>
              <div class="billing-items" style="margin-top:30px">
                <h3>You have {{ items.length }} products.</h3>
                <div v-for="item in items" v-if="items.length">
                  <hr>
                  {{ item.title }} - £{{ item.price }} <br><a href="javascript:;" @click.prevent="$router.push('/billing/'+item.itemId)" class="button account__billing-box__edit-btn is-small is-outlined is-inverted" style="margin-right:5px">Edit</a>
                  <!-- <a href="javascript:;" @click.prevent="delItem(item.itemId)"  class="button account__billing-box__edit-btn is-small is-danger">Remove</a> -->
                </div>
                <div v-if="!items.length">
                  No billing items created.
                </div>
              </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
  name: 'billing',
  data() {
    return {
      isLoading: true,
      items: []
    };
  },
  async created()  {
    this.items = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/billing',
      method: 'POST',
      body: {
        action: 'list'
      }
    });
    this.isLoading = false;
  },
  components: {
  },
  methods: {

    async delItem(itemId) {
      this.isLoading = true;
      const del = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/billing',
        method: 'POST',
        body: {
          action: 'del',
          item: itemId
        }
      });
      this.isLoading = false;
      this.items = this.items.filter(i => {
        return i.itemId != itemId
      });
    },
  },
};
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
